import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as types from '@board/store/types'
import * as accountTypes from '@account/store/types'
import { getProperty, getLangProperty, uGetDateFormat, IEDate } from '@appbase/util';
import * as dateutil from '@appbase/util/date-helper';
import { open, OpenType } from '@board/open-handler'; 

import { LoadingBar } from '@appbase/components/loading'
import { ids } from '@board/module';
import api from '@board/api'

@Component({
    components: {
        LoadingBar
    },

    computed: mapGetters({
        isLoading: types.BOARD_LOADDING,                    
        user: accountTypes.USER,
        current: accountTypes.CURRENT,
        popupBaseUrl: types.POPUP_BASEURL,
        pageSet: types.FETCH_TOTALPAGESET,
        articles: types.FETCH_TOTALARTICLES
    }),

    methods: mapActions({    
        fetchPageSet: types.FETCH_TOTALPAGESET,
        fetchArticels: types.FETCH_TOTALARTICLES
    })
})

export default class TotalBoardList extends Vue {       
    fetchPageSet!: (pageSet: boardModule.state.TotalPageSet) => void;    
    fetchArticels!: (searchSet: article.TotalArticleSearchSet) => Promise<article.PagedData<article.TotalArticle>>;

    user!: account.User;
    current!: account.TCurrent;
    isLoading!: boolean;    
    popupBaseUrl!: string;
    pageSet!: boardModule.state.TotalPageSet;
    articles!: article.TotalArticle[];

    itemsPerPage: number = 15;   
    currentField: number = 0;
    sortOrder: boolean = false;
    searchItems: number = 0;
  
    @Watch('pageSet')
    onPageSetChange(newVal: boardModule.state.TotalPageSet) {
        var searchSet: article.TotalArticleSearchSet = {
            boardGroup: newVal.groupId,
            includeContent: false,
            itemsPerPage: 15,
            page: newVal.currentPage,
            searchField: newVal.searchField,
            searchFieldValue: newVal.searchText,
            sortOrder: false,
            useNotice: false            
        }

        this.fetchArticels(searchSet).then(res => {
            this.searchItems = res.totalCount;
            this.$emit('articlesChanged', this.itemsPerPage, res.totalCount, newVal.currentPage, res.data.length);
        });

    }

    created() {
        this.onPageSetChange(this.pageSet);
    }         
        
    checkArticleExpired(expiredDate: Date | null) {
        if(expiredDate == null) {
            return false;
        } else {
            var tDate = new Date();
            var today = dateutil.uGetDateFormat('yyyy-MM-DD', tDate);

            var eDate = new Date(expiredDate);
            var articlceDate = dateutil.uGetDateFormat('yyyy-MM-DD', eDate);
            return articlceDate < today
        }
    }

    dispDate(article: article.TotalArticle) {
        return uGetDateFormat('yyyy-MM-dd', IEDate(article.createdDate))
    }

    async goDetailPage(article: article.TotalArticle) {    
        if(this.checkArticleExpired(article.expiredDate)) {
            await (window as any).alertAsync(this.$t("M_BB_ExpiredPost").toString());
            return;
        }

        var menuId = this.$route.query.MENUID ? this.$route.query.MENUID.toString() : '';
                      
        open(!this.isTeams ? 
            OpenType.PopupRead : OpenType.ModalRead,
            {
                boardId: article.boardId,
                articleId: article.articleId,
                baseUrl: this.popupBaseUrl,
                query: {
                  MENUID: menuId
                }
            });
    }

    showNewIcon(article: article.Article) {
        var oneDay = 1000 * 60 * 60 * 24;
        var createdDate = new Date(article.createdDate.toString());
        var today = new Date();

        var timeSpan = today.getTime() - createdDate.getTime();


        if (timeSpan <= oneDay) {
            return true;
        } else {
            return false;
        }
    }

    getNoticeCss(article: article.Article) {
        
        var rtCss = 'ft-600'
        if(article.userView){
            rtCss = 'ft-gray'
        }
        return rtCss;   
    }
}